/**
 * AtribucionBancoApiClient -- a que negocio pertenece cada movimiento de una cuenta compartida (BAN-T3, Ares #28212).
 *
 * Contrato: P-CONTRATO-ATRIBUCION-BANCO-BAN-T3_2026-10-15.md (INTERCAMBIO-ARGYS, sha b5d41f52). Las rutas de escritura
 * y de destinos NO existen todavia en nexo-api: las publica A despues de su frente 1. Mientras tanto la pantalla queda
 * apagada (404 = NO_PUBLICADO) y se enciende sola, sin redeploy del panel.
 *   GET  /api/v1/auditoria/bank-movements/atribucion/destinos?businessId=   -> {multiNegocio, destinos[]}
 *   GET  /api/v1/auditoria/bank-movements?businessId=&atribucion=sin-atribuir  (ya existe)
 *   POST /api/v1/auditoria/bank-movements/atribucion  {businessId, movimientos[{bankMovementId, destino}], nota?}
 *
 * El cuerpo se arma aqui, en camelCase. Nunca lanza.
 *
 * @module infrastructure/api/AtribucionBancoApiClient
 */

import { ApiBase } from './ApiBase.js';
import { motivoDelFallo } from './BancoPropuestasApiClient.js';

const BASE = '/api/v1/auditoria/bank-movements';
const TOPE = 500; // el mismo LIMIT de la lista del servidor

const falla = (res) => ({ ok: false, ...motivoDelFallo(res) });

export const AtribucionBancoApiClient = {
  TOPE,

  /** Los destinos posibles de la cuenta y si es multi-negocio. Sin la ruta: NO_PUBLICADO. */
  async destinos(businessId) {
    if (!businessId) return { ok: false, motivo: 'DATOS', detalle: 'falta el negocio' };
    const res = await ApiBase.get(`${BASE}/atribucion/destinos?${new URLSearchParams({ businessId })}`);
    if (!res.ok) return falla(res);
    return { ok: true, data: res.data?.data ?? res.data ?? {} };
  },

  /** Los movimientos sin atribuir de la cuenta (la lista ya existe). */
  async sinAtribuir(businessId) {
    if (!businessId) return { ok: false, motivo: 'DATOS', detalle: 'falta el negocio' };
    const res = await ApiBase.get(`${BASE}?${new URLSearchParams({ businessId, atribucion: 'sin-atribuir' })}`);
    if (!res.ok) return falla(res);
    const d = res.data?.data ?? res.data;
    return { ok: true, data: Array.isArray(d) ? d : (Array.isArray(d?.items) ? d.items : []) };
  },

  /** Atribuye uno o varios movimientos. destino: id de negocio de la cuenta, 'fuera' o null (deshacer). */
  async atribuir({ businessId, movimientos, nota } = {}) {
    const lista = Array.isArray(movimientos) ? movimientos.filter((m) => m && m.bankMovementId) : [];
    if (!businessId || lista.length === 0) return { ok: false, motivo: 'DATOS', detalle: 'no hay movimientos para atribuir' };
    if (lista.length > TOPE) return { ok: false, motivo: 'DATOS', detalle: `maximo ${TOPE} movimientos por vez` };
    const body = {
      businessId,
      movimientos: lista.map((m) => ({ bankMovementId: String(m.bankMovementId), destino: m.destino ?? null }))
    };
    if (nota) body.nota = nota;
    const res = await ApiBase.post(`${BASE}/atribucion`, body);
    if (!res.ok) return falla(res);
    return { ok: true, data: res.data?.data ?? res.data ?? {} };
  }
};
